import { BaseDataModel } from "@domain/BaseDataModel";

export class Grower extends BaseDataModel {
	name!: string;
	companyIds!: string[];
	phoneNumber?: string;
	samplingType?: string;
	readonly unreadyJobCount?: number; // formula
	readonly companiesFromJobs?: string[]; // rollup

	// used for creating new growers from 3rd party integrations
	externalId?: string;
}
